import React from 'react';
import cx from 'classnames';
import { Paper, PaperProps, makeStyles } from '@material-ui/core';
import { units } from 'ha/theme/utils';

type Kind = 'mint' | 'muted' | 'mint-left-no-radius';

const useStyles = makeStyles(theme => ({
  base: {
    display: 'inline-block',
    fontSize: units.rem(0.85),
    padding: units.trbl(0.25, 0.5, 0.25, 0.5),
  },
  'kind-mint': {
    color: '#fff',
    backgroundColor: theme.palette.mint.main,
  },
  'kind-mint-left-no-radius': {
    color: '#fff',
    backgroundColor: theme.palette.mint.main,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  'kind-muted': {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.secondary.main,
  },
}));

interface Props extends PaperProps {
  kind?: Kind;
}

const Badge: React.FC<Props> = ({ kind, children, ...rest }) => {
  const classes = useStyles();

  return (
    <Paper
      elevation={0}
      className={cx(classes.base, {
        [classes[`kind-${kind}`]]: Boolean(kind),
      })}
      {...rest}
    >
      {children}
    </Paper>
  );
};

export default Badge;
